// extracted by mini-css-extract-plugin
module.exports = {"h1":"SeoHeadings_h1__1bjQ9","h2":"SeoHeadings_h2__Uvll-","span":"SeoHeadings_span__1GqLa"};